import React from "react";
import _ from "lodash";
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import NumberFormat from "react-number-format";
import TextField from "@material-ui/core/TextField";
import Button from "components/CustomButtons/Button";
const useStyles = makeStyles((theme) => ({
  field: {
    height: "40px",
    marginTop: 20,
    padding: 15,
    paddingTop: 0,
    borderRadius: 15,
    color: "white",
    backgroundColor: "#363638",
    // boxShadow: "10px 10px 10px 1px rgba(0, 0, 0, 0.5)",
  },
  inputRoot: {
    color: "white",
  },
  showDetail: {
    alignItems: "center",
    marginTop: 5,
    marginBottom: 10,
    justifyContent: "space-around",
    width: "100%",
    color: "white",
    backgroundColor: "transparent",
    fontWeight: 600,
    "& .MuiInputBase-root": {
      color: "white",
    },
    "& fieldset": { color: "black" },
    "& .MuiInputBase-root.Mui-disabled": {
      backgroundColor: theme.palette.background.grey,
      color: "black",
      border: `none`,
      "& fieldset": {
        border: `none`,
      },
    },
    outline: "none",
  },
  hovered: {
    "& fieldset": {},
  },
  focused: {
    "& fieldset": {},
  },
}));

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      style={{ fontSize: "20px", padding: 11 }}
      getInputRef={inputRef}
      allowLeadingZeros={false}
      allowNegative={false}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      
    />
  );
}

export default function CustomOutlinedInput(props) {
  const commonStyle = useStyles();
  const commonClasses = {
    root: commonStyle.showDetail,
  };

  const { classes, disabled, setMax, text, availabletext, token, placeholder } =
    props;
  const filteredProps = _.omit(props, ["setMax", "startAdornment"]);

  if (token) {
    return (
      <div>
        <div>
          <span className="valueHeader">{text}</span>
          <span style={{ float: "right", fontWeight: 600 }}>
            {availabletext}
          </span>
        </div>
        <div className={commonStyle.field}>
          <TextField
            {...filteredProps}
            placeholder={placeholder || "0.0"}
            classes={Object.assign({}, commonClasses, classes)}
            InputProps={{
              startAdornment: props.startAdornment,
              disableUnderline: true,
              endAdornment: (
                <InputAdornment
                  position="end"
                  className={commonStyle.inputAdornment}
                >
                 
                  <img
                    style={{ marginLeft: 10 }}
                    className="smIcon"
                    src={require("assets/img/" + token.token + ".png").default}
                  />
                  <span className="text">{token.token}</span>
                </InputAdornment>
              ),
            }}
          />
        </div>
      </div>
    );
  } else {
    return (
      <div>
        <div className={commonStyle.field}>
          <TextField
            {...filteredProps}
            placeholder={placeholder || "0.0"}
            classes={Object.assign({}, commonClasses, classes)}
            color="secondary"
            InputProps={{
              startAdornment: props.startAdornment,
              disableUnderline: true,
              endAdornment: (
                <InputAdornment
                  position="end"
                  className={commonStyle.inputAdornment}
                >
                
                </InputAdornment>
              ),
            }}
          />
        </div>
        <div>
          <span className="valueHeader">{text}</span>
          <span style={{ float: "right", fontWeight: 600, marginTop: 15 }}>
            {availabletext}
          </span>
        </div>
      </div>
    );
  }
}

CustomOutlinedInput.defaultProps = {
  fullWidth: true,
};
